import { render, staticRenderFns } from "./VideoProjectItemText.vue?vue&type=template&id=0206fb82&scoped=true&"
import script from "./VideoProjectItemText.vue?vue&type=script&lang=js&"
export * from "./VideoProjectItemText.vue?vue&type=script&lang=js&"
import style0 from "./VideoProjectItemText.vue?vue&type=style&index=0&id=0206fb82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0206fb82",
  null
  
)

export default component.exports